import Loadable from 'react-loadable';
import { APP_ID } from '../../config/constants';

const AppNegotiator: any = Loadable({
  loader: () => {
    switch (APP_ID) {
      case 'waste-calendar':
        return import(/* webpackChunkName: "waste-calendar" */ '../../../apps/waste-calendar/containers/App');
      case 'heat-calculator':
        return import(/* webpackChunkName: "heat-calculator" */ '../../../apps/heat-calculator/containers/App');
      case 'reports':
        return import(/* webpackChunkName: "reports" */ '../../../apps/reports/containers/App');
      case 'measurements':
        return import(/* webpackChunkName: "measurements" */ '../../../apps/measurements/containers/App');
      case 'registration-desk':
        return import(/* webpackChunkName: "registration-desk" */ '../../../apps/registration-desk/containers/App');
      case 'container-locations':
        return import(/* webpackChunkName: "container-locations" */ '../../../apps/container-locations/containers/App');
      default:
        return import('../../components/NotFound');
    }
  },
  loading: () => null,
});

export default AppNegotiator;
